var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _g2, _g3, _g4, _g5, _path11, _g6, _g7, _g8, _g9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.616 129.75C124.048 129.75 133.316 120.482 133.316 109.05C133.316 97.6173 124.048 88.3496 112.616 88.3496C101.184 88.3496 91.916 97.6173 91.916 109.05C91.916 120.482 101.184 129.75 112.616 129.75Z",
    fill: "#666363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9922 95.6171L99.1269 93.4824L128.247 122.605L126.112 124.739L96.9922 95.6171Z",
    fill: "#E8E8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.508 103.9L115.642 101.766L119.761 105.882L117.626 108.017L113.508 103.9Z",
    fill: "#E8E8E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.764 110.152L121.898 108.018L126.017 112.132L123.882 114.266L119.764 110.152Z",
    fill: "#E8E8E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.254 97.6503L109.389 95.5156L113.505 99.6319L111.37 101.767L107.254 97.6503Z",
    fill: "#E8E8E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.324 112.184L107.459 110.049L111.575 114.167L109.441 116.302L105.324 112.184Z",
    fill: "#E8E8E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.582 118.435L113.717 116.301L117.835 120.417L115.7 122.552L111.582 118.435Z",
    fill: "#E8E8E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.947 122.635L117.791 124.791L121.025 128.025C121.888 127.594 122.966 127.163 123.829 126.516L119.947 122.635Z",
    fill: "#E8E8E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6406 100.641L96.875 103.875L99.0312 101.719L95.15 97.8379C94.7188 98.916 94.0719 99.7785 93.6406 100.641Z",
    fill: "#E8E8E8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0723 105.936L101.207 103.802L105.323 107.92L103.189 110.053L99.0723 105.936Z",
    fill: "#E8E8E8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M105.284 95.6816L107.44 93.5254L104.205 90.291C103.343 90.7223 102.265 91.1535 101.402 91.8004L105.284 95.6816Z",
    fill: "#E8E8E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.375 117.459L128.141 114.225L125.984 116.381L129.866 120.262C130.512 119.4 130.944 118.537 131.375 117.459Z",
    fill: "#E8E8E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5318_3102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.6441 29.0527L4.80353 106.893C2.64728 108.834 6.09728 115.518 12.1348 121.771C18.1723 127.809 24.8567 131.259 27.0129 129.103L104.854 51.2621L82.6441 29.0527Z",
    fill: "#2A7182"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5318_3102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.129 38.325L133.532 7.70625C133.1 5.98125 132.238 4.25625 130.944 2.9625C129.65 1.66875 127.925 0.80625 126.2 0.375L95.5816 30.7781C92.5629 33.7969 87.6035 33.7969 84.3691 30.7781L102.913 49.3219C99.8941 46.3031 99.8941 41.3437 103.129 38.325Z",
    fill: "#E8E8E8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_d_5318_3102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8742 107.756C26.3648 109.265 24.8555 112.715 24.8555 114.871C25.0711 118.106 27.6586 128.456 27.6586 128.456L104.852 51.2621L94.5023 40.9121C94.5023 40.9121 44.4773 90.9371 27.8742 107.756Z",
    fill: "#BCE0F5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter3_d_5318_3102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1492 106.032C24.6398 107.541 21.1898 109.05 19.0336 109.05C16.0148 108.835 5.44922 106.032 5.44922 106.032L82.643 28.8379L92.993 39.1879C92.993 39.4035 42.968 89.4285 26.1492 106.032Z",
    fill: "#3E4347"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_5318_3102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.128 49.3221C101.403 47.5971 100.756 45.2252 100.971 42.8533C99.0309 41.9908 96.8746 40.9127 94.7184 39.1877C93.209 36.8158 91.9152 34.8752 91.0527 32.9346C88.6809 33.1502 86.309 32.5033 84.584 30.7783C84.584 30.7783 86.309 35.9533 91.0527 42.8533C97.9527 47.5971 103.128 49.3221 103.128 49.3221Z",
    fill: "#3E4347"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.866 11.5875L133.532 7.70625C133.101 5.98125 132.238 4.25625 130.945 2.9625C129.651 1.66875 127.926 0.80625 126.201 0.375L122.535 4.04063C124.045 4.47188 125.77 5.33438 127.063 6.84375C128.573 8.1375 129.435 9.8625 129.866 11.5875Z",
    fill: "#3E4347"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_5318_3102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.363 34.8746L97.3066 29.0527L95.5816 30.7777C94.9348 31.4246 94.0723 32.0715 92.9941 32.5027L102.482 38.7559L102.913 38.3246L106.363 34.8746Z",
    fill: "#2A7182"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_5318_3102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.219 12.234L120.162 6.41211L116.281 10.0777L125.338 15.8996L129.219 12.234Z",
    fill: "#2A7182"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_5318_3102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.672 19.7809L112.616 13.959L108.734 17.6246L117.791 23.4465L121.672 19.7809Z",
    fill: "#2A7182"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_5318_3102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.909 27.3277L105.069 21.5059L101.188 25.3871L110.244 31.209L113.909 27.3277Z",
    fill: "#2A7182"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5318_3102",
    x: 0.158203,
    y: 29.0527,
    width: 108.695,
    height: 108.695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5318_3102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5318_3102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5318_3102",
    x: 80.3691,
    y: 0.375,
    width: 57.1621,
    height: 56.9473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5318_3102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5318_3102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5318_3102",
    x: 20.8555,
    y: 40.9121,
    width: 87.9961,
    height: 95.5439,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5318_3102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5318_3102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5318_3102",
    x: 1.44922,
    y: 28.8379,
    width: 95.543,
    height: 88.2129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5318_3102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5318_3102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_5318_3102",
    x: 80.584,
    y: 30.7783,
    width: 26.543,
    height: 26.5439,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5318_3102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5318_3102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_5318_3102",
    x: 88.9941,
    y: 29.0527,
    width: 21.3691,
    height: 17.7031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5318_3102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5318_3102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_5318_3102",
    x: 112.281,
    y: 6.41211,
    width: 20.9375,
    height: 17.4873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5318_3102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5318_3102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_5318_3102",
    x: 104.734,
    y: 13.959,
    width: 20.9375,
    height: 17.4873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5318_3102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5318_3102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_5318_3102",
    x: 97.1875,
    y: 21.5059,
    width: 20.7227,
    height: 17.7031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5318_3102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5318_3102",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaying);
export default __webpack_public_path__ + "static/media/playing.acd88215eb0ce0609c675afc80c5de18.svg";
export { ForwardRef as ReactComponent };